/**
 *
 * Usage:
 *
 *   data-sw-sortable
 *
 *   the container for the sortable items
 *
 *
 *   data-sw-sortable-item-selector
 *
 *   the selector for the sortable items inside the container
 *   Defaults to: '[data-sw-sortable-item]'
 *
 *
 *   data-sw-sortable-item-order-selector
 *
 *   the selector for the element inside the sortable item to store the order value on
 *   Defaults to: '[data-sw-sortable-item]'
 *
 *
 *   data-sw-sortable-order-attribute
 *
 *   the attribute to store the order value on
 *   Defaults to: 'data-sw-sortable-order'
 *
 */

'use strict';

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-sortable]').each(function() {
    var $el = $(this);
    var sortableItemSelector = $el.data('swSortableItemSelector') || '[data-sw-sortable-item]';
    var sortableItemOrderSelector = $el.data('swSortableItemOrderSelector') || '[data-sw-sortable-item]';
    var sortableOrderAttribute = $el.data('swSortableOrderAttribute') || 'data-sw-sortable-order';

    function updateOrder() {
      $el.children(sortableItemSelector).each(function() {
        var $item = $(this);

        if(sortableItemSelector !== sortableItemOrderSelector) {
          $item.children(sortableItemOrderSelector).attr(sortableOrderAttribute, $item.index());
        } else {
          $item.attr(sortableOrderAttribute, $item.index());
        }
      });
    }

    $el.sortable({
      items: sortableItemSelector
    });

    //give initial items order values
    updateOrder();

    //recalculate order index when an item is moved
    $el.on("sortupdate", updateOrder);
  });
};
